
import { Component, Vue } from 'vue-property-decorator';

import Form5ProcessHeader from "@/components/process/Form5/components/Form5ProcessHeader.vue";
import { form5StatusInfoType } from '@/types/Information/Form5';

@Component({
    components:{
        Form5ProcessHeader
    }
})
export default class CancelSubmitForm5 extends Vue {

    stepsCompleted = {} as form5StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
